import type { FC } from 'react';
import { Box, keyframes, useTheme } from '@/shared/ui/mui';
interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: 'primary' | 'secondary' | 'inherit';
  spacing?: number;
}

const spinAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const LoadingSpinner: FC<LoadingSpinnerProps> = ({
  size = 'medium',
  color = 'primary',
}) => {
  const theme = useTheme();

  const sizeMap = {
    small: 24,
    medium: 40,
    large: 64,
  };

  const spinnerSize = sizeMap[size];
  const borderWidth = size === 'small' ? 2 : size === 'medium' ? 3 : 4;

  const getColor = () => {
    if (color === 'inherit') return 'currentColor';
    if (color === 'secondary') return theme.palette.secondary.main;
    return theme.palette.primary.main;
  };

  return (
    <Box
      data-testid="loading-spinner"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          width: spinnerSize,
          height: spinnerSize,
          borderRadius: '50%',
          border: `${borderWidth}px solid ${theme.palette.grey[200]}`,
          borderTopColor: getColor(),
          animation: `${spinAnimation} 0.8s linear infinite`,
        }}
      />
    </Box>
  );
};
